export default [
	{
		name: 'In Development',
		category: 'in_development'
	},
	{
		name: 'Active',
		category: 'active'
	},
	{
		name: 'Sunset',
		category: 'sunset'
	},
	{
		name: 'Retired',
		category: 'retired'
	},
	{
		name: 'Internal Use',
		category: 'internal_use'
	}
]